import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { membersAPI } from '../../services/api';
import './Pos.css';

const ScanHub = ({ heading = '櫃台掃描' }) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [error, setError] = useState('');
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const focusScan = () => {
    inputRef.current?.focus();
  };

  const onBlur = (event) => {
    const next = event.relatedTarget;
    if (!next) {
      setTimeout(focusScan, 0);
      return;
    }
    const tag = next.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'BUTTON' || tag === 'A') {
      return;
    }
    setTimeout(focusScan, 0);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const value = query.trim();
    if (!value || loading) return;

    setLoading(true);
    setError('');
    setMatches([]);
    try {
      const response = await membersAPI.lookup(value);
      const { match, results } = response.data;
      if (match === 'one' && results[0]) {
        navigate(`/admin/members/${results[0].id}`);
        return;
      }
      if (match === 'many') {
        setMatches(results);
      } else {
        setError('找不到會員');
      }
    } catch (err) {
      setError(err.response?.data?.error || '查詢失敗');
    } finally {
      setLoading(false);
      setQuery('');
      focusScan();
    }
  };

  return (
    <section className="pos-scan">
      <h1>{heading}</h1>
      <p className="pos-hint">掃描器請使用鍵盤模式（HID wedge），游標保持在此欄，掃完會自動查詢。相機並非必須。</p>
      <form onSubmit={onSubmit}>
        <input
          ref={inputRef}
          className="pos-scan-input"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onBlur={onBlur}
          placeholder="會員編號、QR、電話或姓名"
          aria-label="會員掃描"
          autoComplete="off"
          autoFocus
        />
      </form>
      {error && <div className="pos-error">{error}</div>}
      {matches.length > 0 && (
        <div className="pos-match-list">
          {matches.map((member) => (
            <button
              key={member.id}
              type="button"
              className="pos-btn pos-match"
              onClick={() => navigate(`/admin/members/${member.id}`)}
            >
              {member.chinese_name} · {member.member_number}
              {member.phone_number ? ` · ${member.phone_number}` : ''}
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default ScanHub;
